import ContentCard from "../../../../components/misc/ContentCard";
import {
  ActiveExpeditionType,
  ActiveExpeditionView,
} from "../../../../redux/interfaces/expedition.interface";
import ExpeditionSelector, {
  ExpeditionSelectorOption,
} from "./ExpeditionSelector";

const operationOptions: ExpeditionSelectorOption<ActiveExpeditionType>[] = [
  { value: "delivery", label: "Livrari", icon: "DELIVERY_OPERATION" },
  { value: "pickup", label: "Preluari", icon: "PICKUP_OPERATION" },
];

const packagingOptions: ExpeditionSelectorOption<ActiveExpeditionView>[] = [
  { value: "awb", label: "Expeditii colete", icon: "PARCEL_PACKAGING" },
  { value: "bin", label: "Expeditii BIN", icon: "BIN_PACKAGING" },
];

interface Props {
  type: ActiveExpeditionType;
  view: ActiveExpeditionView;
  onChange: (type: ActiveExpeditionType, view: ActiveExpeditionView) => void;
}

function ActiveExpeditionsSelectors({ type, view, onChange }: Props) {
  return (
    <ContentCard cardBodyClassName="flex flex-col gap-5">
      <ExpeditionSelector
        label="Tip expeditii"
        value={type}
        options={operationOptions}
        appearance="cards"
        onChange={(nextType) => onChange(nextType, view)}
      />
      <ExpeditionSelector
        label="Tip ambalaj"
        value={view}
        options={packagingOptions}
        appearance="segmented"
        onChange={(nextView) => onChange(type, nextView)}
      />
    </ContentCard>
  );
}

export default ActiveExpeditionsSelectors;
